<template>
    <div>
        <b-row>
            <b-col>
                <c-title
                    :state="checkState($v.form.intended_position)"
                    :label="$t('form.label.intended_position') + '*'"
                    :placeholder="$t('form.placeholder.intended_position')"
                    :value.sync="$v.form.intended_position.$model"
                >
                    <span v-if="!$v.form.intended_position.maxLength">
                        {{
                            $t('form.validations.maxLength', {
                                value: '255',
                            })
                        }}
                    </span>
                    <span v-if="!$v.form.intended_position.required">{{
                        $t('form.validations.required')
                    }}</span>
                </c-title>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <c-description
                    :state="checkState($v.form.description)"
                    :value.sync="$v.form.description.$model"
                    :label="
                        descriptionIsRequired
                            ? $t('form.label.description') + '*'
                            : $t('form.label.description')
                    "
                    :placeholder="$t('form.placeholder.planDescription')"
                >
                    <span v-if="!$v.form.description.required">{{
                        $t('form.validations.required')
                    }}</span>
                </c-description>
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12" lg="6">
                <c-departments
                    :showLabel="true"
                    :label="$t('careerObjective.interestedAreas') + '*'"
                    :state="checkState($v.form.departments)"
                    :value.sync="$v.form.departments.$model"
                    :loadDataWhenMounted="true"
                >
                    <span v-if="!$v.form.departments.required">{{
                        $t('form.validations.minItems', {
                            value: '1',
                        })
                    }}</span>
                </c-departments>
            </b-col>
            <b-col>
                <c-career-objective-type
                    :label="$t('form.label.planType') + '*'"
                    :state="checkState($v.form.type)"
                    :value.sync="$v.form.type.$model"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col md="12" lg="6">
                <c-years
                    :label="$t('form.label.period') + '*'"
                    :value.sync="$v.form.period.$model"
                    :state="checkState($v.form.period)"
                />
            </b-col>
            <b-col>
                <c-yes-or-no
                    :label="$t('form.label.availabilityForChanges') + '?*'"
                    :value.sync="$v.form.hasMobility.$model"
                    :state="checkState($v.form.hasMobility)"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <c-text-area
                    :state="checkState($v.form.mobilityDescription)"
                    :value.sync="$v.form.mobilityDescription.$model"
                    :label="
                        descriptionIsRequired
                            ? $t('careerObjective.mobility') + '*'
                            : $t('careerObjective.mobility')
                    "
                    :placeholder="$t('form.placeholder.mobilityDescription')"
                >
                    <span v-if="!$v.form.mobilityDescription.required">{{
                        $t('form.validations.required')
                    }}</span>
                </c-text-area>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <p class="font-italic text-muted">
                    {{ $t('form.warning.requiredFields') }}
                </p>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <div class="float-right">
                    <b-button
                        class="mr-1"
                        variant="secondary"
                        @click="$router.back()"
                        >{{ $t('form.button.cancel') }}</b-button
                    >
                    <c-button-loader
                        type="submit"
                        variant="primary"
                        :loader="isSubmitting"
                        @click="onClickSave"
                        >{{ $t('form.button.save') }}</c-button-loader
                    >
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import {
    Title as CTitle,
    Description as CDescription,
    Departments as CDepartments,
    Years as CYears,
    CareerObjectiveType as CCareerObjectiveType,
    YesOrNo as CYesOrNo,
    CTextArea,
} from '@/views/components/fields'
import CButtonLoader from '@/views/components/button-loader'
import { validationMixin } from 'vuelidate'
import { checkState } from '../../functions'
import {
    required,
    requiredIf,
    minLength,
    maxLength,
} from 'vuelidate/lib/validators'

export default {
    name: 'Form',
    components: {
        CYears,
        CTitle,
        CYesOrNo,
        CTextArea,
        CCareerObjectiveType,
        CDepartments,
        CDescription,
        CButtonLoader,
    },
    mixins: [validationMixin],
    props: {
        careerObjective: {
            type: Object,
            required: true,
        },
        isSubmitting: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            form: Object.assign({}, this.careerObjective),
        }
    },
    validations: {
        form: {
            id: {
                required,
            },
            intended_position: {
                required,
                maxLength: maxLength(255),
            },
            description: {
                required: requiredIf(
                    vuelidateModel => vuelidateModel.type == 'career'
                ),
            },
            mobilityDescription: {
                required: requiredIf(
                    vuelidateModel => vuelidateModel.type == 'career'
                ),
            },
            hasMobility: {
                required,
            },
            type: {
                required,
            },
            period: {
                required,
            },
            departments: {
                required,
                minLength: minLength(1),
            },
        },
    },
    methods: {
        checkState,
        onClickSave() {
            if (this.validate()) {
                this.$emit('save', this.form)
            }
        },
        validate() {
            this.$v.$touch()
            return !this.$v.$invalid
        },
    },
    computed: {
        descriptionIsRequired() {
            return this.$v.form.type.$model == 'career'
        },
    },
}
</script>
